// Actively unregister any existing service workers and clear all caches.
// This prevents stale cached content from breaking the app on mobile.

export function register(config) {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          console.log('[SW] Self-uninstalling SW registered:', registration);
        })
        .catch((error) => {
          console.error('[SW] Registration failed:', error);
        });
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    // Unregister all service workers
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (let registration of registrations) {
        registration.unregister().then(() => {
          console.log('[SW] Unregistered service worker');
        });
      }
    }).catch((error) => {
      console.error('[SW] Unregister error:', error.message);
    });

    // Also clear all caches to prevent stale content on mobile
    if ('caches' in window) {
      caches.keys().then((cacheNames) => {
        cacheNames.forEach((cacheName) => {
          caches.delete(cacheName).then(() => {
            console.log('[Cache] Deleted cache:', cacheName);
          });
        });
      }).catch((error) => {
        console.error('[Cache] Error clearing caches:', error);
      });
    }
  }
}
